module.exports = __webpack_public_path__ + "media/images/icons/outlined/percentage-6bea287677b290ec8473f71f63ae832a.svg";